import { Component, Injector, ViewEncapsulation, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
    WebShopServiceProxy,
    BasketArticleDto,
} from '@shared/service-proxies/service-proxies';
import { NotifyService } from 'abp-ng2-module';
import { AppComponentBase } from '@shared/common/app-component-base';

import { appModuleAnimation, RedirectService } from '@axilla/axilla-shared';
import * as _ from 'lodash-es';
import { take, finalize } from 'rxjs/operators';

import { WebshopService } from '@app/shared/common/shop-system/services/webshop.service';
import { ConfirmOrderModel, ConfirmOrderStep } from '../models';
import { AppConsts } from '../../../../shared/AppConsts';

@Component({
    templateUrl: './confirm-order.component.html',
    styleUrls: ['../../dashboard/dashboard.component.less', './confirm-order.component.less'],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()]
})
export class ConfirmOrderComponent extends AppComponentBase implements OnInit, OnDestroy {
    get confirmOrdersModel(): ConfirmOrderModel {
        return this._confirmOrdersModel;
    }
    set confirmOrdersModel(value: ConfirmOrderModel) {
        this._confirmOrdersModel = value;
    }

    get activeStep(): number {
        return 0;
        //return this.confirmOrdersModel.currentStep;
    }

    get steps(): ConfirmOrderStep[] {
        return this.confirmOrdersModel.steps;
    }

    get totalSteps(): number {
        return this.confirmOrdersModel.totalSteps - 1;
    }

    get stepNumber(): number {
        return this.confirmOrdersModel.stepNumber;
    }


    get currentStep(): ConfirmOrderStep {
        return this.confirmOrdersModel.currentStep;
    }

    get stepName(): string {
        return this.currentStep.stepName;
    }

    constructor(
        injector: Injector,
        private _webshopService: WebshopService
    ) {
        super(injector);

        this.confirmOrdersModel = new ConfirmOrderModel(this.basket);
    }


    get selectedDelivery(): any {
        return this._webshopService.selectedDelivery;
    }

    private _confirmOrdersModel: ConfirmOrderModel;


    private _basket: BasketArticleDto[];

    loading = false;


    //#region Step



    updateBasketSubscription$;

    showIsRequired = false;
    //#endregion Agreement

    //#endregion

    //#region MOVE to shared
    remoteServiceBaseUrl = AppConsts.remoteServiceBaseUrl;

    confirmOrderData: any;


    getStepState(stepNumber: number): string {
        return this.confirmOrdersModel.getStepState(stepNumber);
    }


    ngOnInit(): void {
        this._onBasketUpdate();

        this.loading = true;
        this._initConfirmOrder();

        if (this.isOuBlocked) {
            this.showIsBlockedMessage();
        } else {
            this.checkIsOuBlocked();
        }
    }


    ngOnDestroy(): void {
        this.updateBasketSubscription$.unsubscribe();
    }
    private _onBasketUpdate() {
        this.updateBasketSubscription$ = this._webshopService.basketUpdate$
            .subscribe((items: BasketArticleDto[]) => {
                this.confirmOrdersModel = new ConfirmOrderModel(items);

                this.loading = true;
                this._initConfirmOrder();
            });
    }



    //#region TransportStep
    validateDeliveryStep(): boolean {
        if (this.stepName !== 'TransportStep') {
            return true;
        } else {
            return !!this.selectedDelivery;
        }
    }

    selectDelivery(delivery: any) {
        this._webshopService.selectDelivery(delivery);
    }

    //#endregion TransportStep

    //#region Agreement
    validateAgreement(): boolean {
        let state = this._webshopService.validateAgreement();

        if (!state) {
            this.showIsRequired = true;
        } else {
            this.showIsRequired = false;
        }

        return state;
    }


    validateInitialAgreement(): boolean {
        if (this.confirmOrderData.agreements.length > 0) {

            let state = true;

            _.forEach(this.confirmOrderData.agreements, (agreement) => {
                if (!agreement.optional && !agreement.value) {
                    state = false;
                }
            });

            return state;
        }

        return false;
    }

    acceptAgreement(agreement: any) {
        this._webshopService.acceptAgreement(agreement);

        if (!agreement.optional) {
            this.validateAgreement();
        }
    }
    //#endregion


    getCurrency() {
        return this._webshopService.getCurrency();
    }

    private _initConfirmOrder() {

        this._webshopService.getShipmentArticles$().pipe(
            take(1),
            finalize(() => { this.loading = false; })
        ).subscribe((result) => {

            this.confirmOrderData = {
                articles: this._webshopService.documents,
                delivery: this._webshopService.delivery,
                payment: [
                    'Stripe',
                    'Mollie'
                ],
                additionalDocuments: [],
                agreements: [
                    {
                        'optional': true,
                        'text': 'I want to receive mails',
                        'value': false,
                        'id': 1
                    },
                    {
                        'optional': false,
                        'text': 'I accept terms and conditions of this shop',
                        'value': false,
                        'id': 2
                    }
                ],
            };
        });
    }


    isDisableToMoveNext(): boolean {
        return this.confirmOrdersModel.checkIfNextStepAvilable();
    }

    isDisableToMoveBack(): boolean {
        return this.confirmOrdersModel.checkIfPrevStepAvilable();
    }




    goNext() {

        if (this.stepName === 'TransportStep') {
            if (this.validateDeliveryStep()) {
                this.confirmOrdersModel.next();
            }
        } else if (this.stepName === 'AgreementStep') {

            let state = this.validateInitialAgreement();

            if (!state) {
                this.showIsRequired = true;
            } else {
                this.confirmOrdersModel.next();
            }
        } else {
            this.confirmOrdersModel.next();
        }


    }

    goBack() {
        this.confirmOrdersModel.prev();
    }

    confirmOrder() {
        abp.message.info('Order is confirm');

        this._webshopService.resetAll();
    }

}

